import {Tooltip, view} from '@sail/ui';
import {Icon} from '@sail/ui/deprecated';
import {warning} from '@sail/icons/react/Icon';
import {ChatButtonOption, Option} from './ChatButtonOption';
import {useUniversalHelpDotComDesign} from '../../FeatureFlagsProvider';

export type Props = {
  options: Option[];
  selectedOptionId?: string;
  disabled?: boolean;
  error?: React.ReactNode;
  animated?: boolean;
};

const ErrorMessage = ({children}: {children: React.ReactNode}): JSX.Element => {
  return (
    <Tooltip
      placement="left"
      delay={0}
      trigger={
        <Icon
          icon={warning}
          aria-label="warning"
          color="red"
          data-testid="error-tooltip-icon"
        />
      }
    >
      {children}
    </Tooltip>
  );
};

export const ChatButtonOptions = ({
  options,
  selectedOptionId,
  disabled,
  error,
  animated,
}: Props) => {
  const useDotComDesign = useUniversalHelpDotComDesign();

  const buttons = options.map((option, index) => (
    <ChatButtonOption
      key={`button-option-${option.value}`}
      index={index}
      selected={option.value === selectedOptionId}
      disabled={!!selectedOptionId}
      hidden={!!selectedOptionId && option.value !== selectedOptionId}
      option={option}
      animated={animated}
      onPress={() => {
        option.onPress && option.onPress();
      }}
    />
  ));

  return (
    <view.div
      data-testid="button-options-container"
      className="button-options-container"
      css={{
        stack: 'y',
        justifyContent: 'flex-end',
        alignItems: 'flex-end',
        gap: 'small',
        overflow: 'visible',
        ...(useDotComDesign
          ? {
              overflow: 'hidden',
              contain: 'layout',
              justifyContent: 'unset',
            }
          : {}),
      }}
    >
      {disabled && !selectedOptionId ? null : buttons}
      {error ? <ErrorMessage>{error}</ErrorMessage> : null}
    </view.div>
  );
};
